import React, { useState } from 'react';

// Photo with a generated avatar fallback (used when no photo is set or it fails to load).
export default function Avatar({ src, name, seed = 0 }) {
  const [failed, setFailed] = useState(false);
  if (src && !failed) {
    return <img src={src} alt={name} loading="lazy" onError={() => setFailed(true)} />;
  }
  const tones = ['#34373f', '#0b2a15', '#061609'];
  return (
    <svg viewBox="0 0 200 220" role="img" aria-label={name} preserveAspectRatio="xMidYMid slice">
      <rect width="200" height="220" fill={tones[seed % 3]} />
      <circle cx="100" cy="86" r="38" fill="#80c342" opacity=".85" />
      <path d="M32 220c0-56 30-82 68-82s68 26 68 82z" fill="#80c342" opacity=".6" />
    </svg>
  );
}
